import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

import { useStoreRooms } from '@/app/store/pinia/rooms/rooms'

import { GUEST_ROOM_CHAT } from '@/shared/utils/constants'

export const beforeEnterPrepareToCall = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  try {
    await useStoreRooms().awaitForRoomAdded(to.params.roomId as string)
    next()
  } catch {
    next({ name: GUEST_ROOM_CHAT })
  }
}
